import React from 'react';
import clsx from 'clsx';

import ArrowRightIcon from 'app/assets/svgs/ArrowRightIcon';

interface InputButtonProps {
  disabledButton?: boolean;
  imageClassName?: string;
  imageUrl?: string;
  label: string;
  placeholder: string;
  text: string | number;

  onClick: () => void;
}

export const InputButton = ({
  disabledButton = false,
  imageClassName,
  imageUrl,
  label,
  placeholder,
  text,
  onClick: handleClick,
  ...rest
}: InputButtonProps) => {
  const btnVariant = {
    'opacity-50': disabledButton === true,
  };

  let displayText: string;
  if (typeof text === 'number' && text === 0) {
    displayText = '';
  } else {
    displayText = `${text}`;
  }

  return (
    <div
      className={clsx(
        'border border-solid border-grayscale rounded-lg p-4 relative flex justify-between items-center dark:border-dark-light',
        btnVariant,
      )}
      {...rest}
    >
      <span className="text-sm text-typo-normal font-light absolute -top-3 bg-white px-2 dark:bg-dark dark:text-grayscale-lighter">
        {label}
      </span>
      <div>
        {displayText !== '' ? (
          <div className="flex items-center">
            {!!imageUrl && (
              <img
                src={imageUrl}
                alt={displayText}
                data-testid="input-image"
                className={clsx(
                  'mr-2 h-16 w-16 object-contain',
                  imageClassName,
                )}
              />
            )}
            <span className="text-typo-normal font-medium dark:text-grayscale-lighter">
              {displayText}
            </span>
          </div>
        ) : (
          <span className="text-typo-placeholder font-medium dark:text-dark-light">
            {placeholder}
          </span>
        )}
      </div>
      <button
        type="button"
        className="flex w-6 h-6 items-center justify-center dark:text-grayscale-lighter"
        disabled={disabledButton}
        onClick={handleClick}
      >
        <ArrowRightIcon />
      </button>
    </div>
  );
};
